import { ConstantNodeWidget } from './ConstantNodeWidget';
import { ConstantNodeModel } from './ConstantNodeModel';
import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
export class ConstantNodeFactory extends AbstractReactFactory {
  constructor() {
    super('constant');
  }

  generateReactWidget(event) {
    let reduxProps = event.model.options.reduxProps;
    return /*#__PURE__*/React.createElement(ConstantNodeWidget, {
      removeConstantNode: reduxProps["removeConstantNode"],
      renameConstantNode: reduxProps["renameConstantNode"],
      engine: this.engine,
      size: 50,
      model: event.model
    });
  }

  generateModel(event) {
    return new ConstantNodeModel();
  }

}